package com.oratakashi.web.resources

import com.varabyte.kobweb.compose.css.CSSTransition
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.silk.components.forms.ButtonVars
import com.varabyte.kobweb.silk.components.style.ComponentStyle
import com.varabyte.kobweb.silk.components.style.addVariantBase
import com.varabyte.kobweb.silk.components.style.hover
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px

val ButtonSolidStyle by ComponentStyle(prefix = "silk") {
    base {
        Modifier
            .backgroundColor(ButtonVars.BackgroundDefaultColor.value())
            .setVariable(ButtonVars.BackgroundDefaultColor, R.colors.PRIMARY_500.value)
            .setVariable(ButtonVars.BackgroundHoverColor, R.colors.PRIMARY_300.value)
            .padding(leftRight = 20.px)
            .borderRadius(R.dimens.BORDER_RADIUS.px)
            .boxShadow(
                color = R.colors.SHADOW_COLORS.value.toRgb().copy(alpha = 20),
                blurRadius = 60.px,
                spreadRadius = 50.px
            )
            .transition(CSSTransition(property = TransitionProperty.All, duration = 300.ms))
    }
    hover {
        Modifier
            .backgroundColor(R.colors.PRIMARY_300.value)
            .padding(leftRight = 26.px)
    }
}

val ButtonSoftStyle by ComponentStyle(prefix = "silk") {
    base {
        Modifier
            .backgroundColor(ButtonVars.BackgroundDefaultColor.value())
            .setVariable(ButtonVars.BackgroundDefaultColor, R.colors.PRIMARY_100.value)
            .setVariable(ButtonVars.BackgroundHoverColor, R.colors.PRIMARY_400.value)
            .padding(leftRight = 20.px)
            .borderRadius(R.dimens.BORDER_RADIUS.px)
            .transition(CSSTransition(property = TransitionProperty.All, duration = 300.ms))
    }
    hover {
        Modifier
            .backgroundColor(R.colors.PRIMARY_200.value)
            .padding(leftRight = 26.px)
    }
}